import type { FeatureFlagContext } from './launchDarklyClient'
import { identifyLaunchDarkly } from './launchDarklyClient'
import { useCallback } from 'react'

export type { FeatureFlagContext }

/**
 * Returns a setter for the flag evaluation identity.
 *
 * Memoised so it stays safe to list in an effect's dependency array.
 */
export const useFeatureFlagContext = (): (context: FeatureFlagContext) => void =>
  useCallback((context: FeatureFlagContext) => {
    identifyLaunchDarkly(context.userId)
  }, [])
